import React from "react";
import {
  PreloadedModulesCtx,
  RegisterSSRModuleCtx,
  viteReactLoadableApiKey,
} from "./shared";
import {
  promiseAllModules,
  getImportChunkMap,
} from "virtual:react-loadable-manifest";

import { ImportChunkMap } from "@dynamic/types";

export class ImportCollector {
  allModules: Record<string, any>;
  tracked: Set<string>;
  importChunkMap: ImportChunkMap | undefined;

  constructor() {
    this.allModules = {};
    this.tracked = new Set();
    this.importChunkMap;
  }

  async preload() {
    this.allModules = await promiseAllModules();
    this.importChunkMap = getImportChunkMap();
  }

  provide(children: JSX.Element) {
    const main = (
      <PreloadedModulesCtx.Provider value={this.allModules}>
        {children}
      </PreloadedModulesCtx.Provider>
    );

    if (typeof window === "undefined") {
      return (
        <RegisterSSRModuleCtx.Provider value={this.tracked}>
          {main}
        </RegisterSSRModuleCtx.Provider>
      );
    }

    return main;
  }

  toClientScript() {
    let statements: string[] = [];
    statements.push(`var loadedModules = {}`);
    statements.push(
      `var modulePromises = {${[...this.tracked]
        .map((item) => {
          const importPaths = this.importChunkMap?.[item];
          if (!importPaths) return "";
          return `"${item}": import("${importPaths.jsModule.replace(
            process.cwd(),
            ""
          )}").then(result => loadedModules["${item}"] = result),`;
        })
        .join("\n")}}`
    );
    statements.push(`var api = {
      promiseAllModules() {
        return Promise.all(Object.values(modulePromises)).then(() => loadedModules)
      }
    }`);
    statements.push(`window.${viteReactLoadableApiKey} = api`);
    return statements.join("\n");
  }

  preloadPaths() {
    const files: string[] = [];
    [...this.tracked].forEach((item) => {
      const importPaths = this.importChunkMap?.[item];

      importPaths?.preload.forEach((chunkPath) => {
        files.push(chunkPath);
      });
    });

    return files;
  }
}
